import React from 'react';
import { STATUSES } from '../shared/exchanges';
import { Icon } from './components';

export default function DossierStatusPath({ status, onChange, disabled = false, busy = false }) {
  const steps = Object.entries(STATUSES);
  const current = steps.findIndex(([key]) => key === status);
  return <div className="ex-status-path-scroll">
    <ol aria-busy={busy} className="ex-status-path" aria-label="Progression du dossier" role="list">
      {steps.map(([key, label], index) => {
        const state = index === current ? 'current' : index < current ? 'past' : 'next';
        return <li key={key} className={`ex-status-step ex-status-step--${state}`} aria-current={state === 'current' ? 'step' : undefined}>
          <button type="button" className="ex-status-step-button" disabled={disabled} aria-pressed={state === 'current'} onClick={() => onChange(key)} aria-label={state === 'current' ? `${label} · Statut actuel` : `Passer le dossier au statut ${label}`}>
          <span className="ex-status-step-marker" aria-hidden="true">{state === 'past' ? <Icon name="check" size={17} /> : index + 1}</span>
          <span>{label}<span className="ex-sr-only">{state === 'current' ? ' · Statut actuel' : state === 'past' ? ' · Étape précédente' : ' · Étape suivante'}</span></span>
          </button>
        </li>;
      })}
    </ol>
  </div>;
}
